module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "spinner-container container1"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container2"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container3"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08f3558a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spin.vue
// module id = 530
// module chunks = 1